// extracted by mini-css-extract-plugin
export default {"mainCol":"app_accountPage_mainCol__pvetA"};